/**
 * @file Manages Tsr Tour
 * @author François Thiounn
 */

import * as React from 'react'
import I18n from '../../locales/I18n'
import { OnboardingTooltip } from '@domoscio/domoscio-ui'
import Joyride from 'react-joyride'
import { User } from '../../contexts/parameters/parametersWrapper'
import { domUtils } from '@domoscio/domoscio-sdk-js'
import { useRiseUpClient } from '../../hooks/useRiseUpClient'

interface Props {
  children: React.ReactNode
  isReady: boolean
}

export default function TsrTour({ ...props }: Props) {
  const { isRiseup } = useRiseUpClient()
  const user = React.useContext(User.State)
  const userDispatch = React.useContext(User.Dispatch)

  const shouldRunTour = () => {
    if (isRiseup) {
      return false
    } else {
      return !(user?.onboarding?.lxp_lock?.tsr ?? false)
    }
  }
  const runTour = shouldRunTour()

  const steps = [
    {
      target: '.tour-tsr-step1',
      title: I18n.t('tour.title.step1'),
      content: I18n.t('tour.tsr.step1.content'),
      disableBeacon: true,
      placement: 'bottom' as const
    },
    {
      target: '.tour-tsr-step2',
      title: I18n.t('tour.title.step2'),
      content: I18n.t('tour.tsr.step2.content'),
      disableBeacon: true,
      placement: 'top' as const
    }
  ]

  const handleJoyrideCallback = data => {
    const { action, status } = data
    if (status === 'finished' || action === 'reset') {
      userDispatch({
        onboarding: domUtils.updateTour(user.onboarding, 'lxp_lock', { tsr: true })
      })
    }
  }

  return (
    <>
      <Joyride
        floaterProps={{ disableAnimation: true }}
        run={runTour && props.isReady}
        steps={steps}
        continuous={true}
        showSkipButton={true}
        tooltipComponent={OnboardingTooltip}
        callback={handleJoyrideCallback}
      />
      {props.children}
    </>
  )
}
